export default `
  query getActiveSubscription {
    getActiveSubscription {
      success
      message
      payerUserId
      payerUserEmail
      subscriptionDetails {
        subscriptionId
        status
        nextBillingDate
        nextBillingAmount
        price {
          id
          unitAmount
          currency
          productName
        }
        cardDetails {
          lastFour
          brand
        }
        quantity
        cancelAt
      }
      scheduleSubscriptionDetails {
        scheduleId
        status
        phases {
          startDate
          endDate
          items {
            priceId
            quantity
          }
        }
      }
      lastSubscriptionDetails {
        subscriptionId
        status
        price {
          id
          unitAmount
          currency
          productName
        }
        quantity
        clientSecret
      }
    }
  }
`
